/* eslint-disable import/no-anonymous-default-export */
export default {
  GET_VERSION: 'GET_VERSION',
  GET_VERSION_PENDING: 'GET_VERSION_PENDING',
  GET_VERSION_FULFILLED: 'GET_VERSION_FULFILLED',
  GET_VERSION_REJECTED: 'GET_VERSION_REJECTED',
};
